/* ==========================================================================
   VoxTune — Global UI Sound Manager
   ONE engine for interface sounds. Only one "sound profile" is active at a
   time (homepage → program → cart → checkout …), so playback never overlaps.
   Honors a user preference (enabled + volume) persisted to localStorage.
   Registered as VoxTune module 'sound'. Plays via VT.emit('sound:play', name).
   ========================================================================== */
(function (w) {
  'use strict';
  var VT = w.VoxTune;
  if (!VT) return;

  VT.module('sound', function (VT) {
    var cfg = (VT.shop && VT.shop.sound) || { enabled: true, volume: 0.35 };
    var LS = 'voxtune_sound';
    var pref = readPref();
    var buffers = {};       // name -> HTMLAudioElement (cloned per play)
    var sources = {};       // name -> url
    var activeProfile = 'home';
    var unlocked = false;
    var lastPlay = {};      // source url -> last play time (debounce identical sounds)

    function readPref() {
      try { var p = JSON.parse(localStorage.getItem(LS)); if (p) return p; } catch (e) {}
      return { enabled: cfg.enabled !== false, volume: typeof cfg.volume === 'number' ? cfg.volume : 0.35, muted: false };
    }
    function writePref() { try { localStorage.setItem(LS, JSON.stringify(pref)); } catch (e) {} }

    function register(map) { Object.keys(map || {}).forEach(function (k) { if (map[k]) sources[k] = map[k]; }); }

    function el(name) {
      if (!sources[name]) return null;
      if (!buffers[name]) { var a = new Audio(sources[name]); a.preload = 'none'; buffers[name] = a; }
      return buffers[name];
    }

    function canPlay() { return pref.enabled && !pref.muted; }

    function play(name) {
      if (!canPlay() || !unlocked) return;
      var src = sources[name]; if (!src) return;
      // Debounce identical sounds: collapses a double-trigger (delegation + an
      // explicit emit on the same click) and stops rapid-click spam. Distinct
      // sounds, or the same one >60ms apart, still play.
      var now = Date.now();
      if (lastPlay[src] && now - lastPlay[src] < 60) return;
      lastPlay[src] = now;
      var base = el(name); if (!base) return;
      // clone so rapid (>debounce) repeats overlap cleanly without cutting each other
      var node = base.cloneNode();
      node.volume = Math.max(0, Math.min(1, pref.volume));
      var p = node.play(); if (p && p.catch) p.catch(function () {});
    }

    // Sound profiles: switching stops any looping ambient sound of the previous
    // profile and announces the change. (UI cues are one-shots, so this mostly
    // guards future ambient loops and keeps a single source of truth.)
    function profile(name) {
      if (name === activeProfile) return;
      VT.emit('sound:profile:leave', activeProfile);
      activeProfile = name;
      VT.emit('sound:profile:enter', name);
    }

    // First user gesture unlocks audio (mobile autoplay policy).
    function unlock() {
      if (unlocked) return; unlocked = true;
      document.removeEventListener('pointerdown', unlock);
      document.removeEventListener('keydown', unlock);
      // Warm buffers now that interaction has unlocked audio — snappy first play,
      // and nothing is fetched before the user has actually interacted.
      Object.keys(sources).forEach(function (n) { var a = el(n); if (a) { try { a.preload = 'auto'; a.load(); } catch (e) {} } });
    }
    document.addEventListener('pointerdown', unlock, { once: false });
    document.addEventListener('keydown', unlock, { once: false });

    // Public preference controls (a settings UI can call these).
    function setEnabled(v) { pref.enabled = !!v; writePref(); VT.emit('sound:pref', pref); }
    function setVolume(v) { pref.volume = Math.max(0, Math.min(1, v)); writePref(); VT.emit('sound:pref', pref); }
    function setMuted(v) { pref.muted = !!v; writePref(); VT.emit('sound:pref', pref); }

    // Wire events + unified click delegation. Capture phase so it fires even
    // when a downstream handler calls stopPropagation (e.g. the funnel). Routing:
    //   [data-sfx="x"]  → sound x   (use "none"/"off" to silence an element)
    //   checkout buttons → Sound 3 (checkout)
    //   any other button / link / role=button → Sound 1 (general click)
    // DAW option buttons carry data-sfx="daw" (Sound 2), so they resolve above.
    VT.on('sound:play', play);
    VT.on('sound:profile', profile);
    document.addEventListener('click', function (e) {
      var node = e.target;
      if (!node || !node.closest) return;
      var tagged = node.closest('[data-sfx]');
      if (tagged) { var n = tagged.getAttribute('data-sfx') || 'click'; if (n !== 'none' && n !== 'off') play(n); return; }
      if (node.closest('[data-vp-checkout],.vp-checkout,.vp-decline,.vp-to-cart2')) { play('checkout'); return; }
      if (node.closest('button,a[href],[role="button"],summary')) play('click');
    }, true);

    return { register: register, play: play, profile: profile, setEnabled: setEnabled, setVolume: setVolume, setMuted: setMuted, get pref() { return pref; } };
  });
})(window);
